<template lang="pug">
    .container
        include BlogCategory.pug
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'BlogCategory',
  props: ['slug'],
  computed: mapState([
    "context",
  ]),
  data() {
    return {
      selectVisible: false,
      entries: [],
    }
  },
  created() {
    const _this = this
    this.$wagtail.getEntries(this.slug).then((response) => {
      let data = response.data
      _this.entries = data.results
      console.log(_this.entries)
    })
  },
  methods: {
    showCategories() {
      this.selectVisible = !this.selectVisible
    },
  },
}
</script>

<style scoped lang="scss">
@import './../../variables';

@import 'BlogCategory';
</style>



// WEBPACK FOOTER //
// src/components/blog/BlogCategory.vue